//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import cmFooter from '@/components/cmFooter.vue'
export default {
  name: 'home',
  components: {
      cmFooter
  },
  data () {
    return {
      type:1,
      count:[],
      info:{},
      nav:[
        //  {
        //   title:'洗衣',
        //   path:'/wash',
        //   auth:'wash',
        //   img:'/static/images/washed.png',
        // },
        {
          title:'家政',
          path:'/clean',
          auth:'clean',
          img:'/static/images/cleaned.png',
        },
        {
          title:'商品',
          path:'/product',
          auth:'product',
          img:'/static/images/producted.png',
        },
        // {
        //   title:'采购',
        //   path:'/purchase',
        //   auth:'purchase',
        //   img:'/static/images/pickup.png',
        // },
        // {
        //   title:'洗衣录单',
        //   path:'/recordOrder',
        //   auth:'recordOrder',
        //   img:'',
        // },
      ],
    }
  },
  created(){
    if(this.$func.getLocal('token')){
      this.getOrderCount();
    }else{
      this.$router.push({path:'/login'})
    }
  },
  mounted(){
    this.getInfo();
  },
  methods:{
    getOrderCount(){
      this.$api.getOrderCount({type:this.type}).then((res)=>{
        this.count = res.data;
      })
    },
    getInfo(){
      this.$api.getInfo({}).then((res)=>{
        if(res){
          if(!Number(res.data.cid)){
              this.$router.push({path:'/login'})
              return false;
          }
          this.info = res.data;
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/home.vue